import {useQuery} from '@tanstack/react-query';
import {apiClient} from '@/shared/services';
import {buildMembershipPlans, FALLBACK_MEMBERSHIP_PLANS, type MembershipPlan} from '../constants/membershipPlans';

/**
 * Membership plan pricing, served by the API (env-overridable server-side)
 * so display and charge can never diverge. Falls back to the launch prices
 * until the fetch resolves; prices change rarely, hence the long staleTime.
 */
export function useMembershipPlans(): MembershipPlan[] {
    const {data} = useQuery<{plans: Array<{id: string; amount_cents: number}>}>({
        queryKey: ['membership', 'plans'],
        queryFn: () => apiClient.get('/api/membership/plans'),
        staleTime: 5 * 60 * 1000,
    });
    return data?.plans ? buildMembershipPlans(data.plans) : FALLBACK_MEMBERSHIP_PLANS;
}
